interface TrustBarItem {
  value: string;
  label: string;
}

interface TrustBarProps {
  items: TrustBarItem[];
  variant?: "light" | "dark";
}

const variantStyles = {
  light: { bg: "bg-background", value: "text-accent", label: "text-muted-foreground" },
  dark: { bg: "bg-primary", value: "text-accent", label: "text-primary-foreground/50" },
};

/**
 * Horizontal strip of stats or credentials.
 * For logo-based trust strips, use the existing TrustStrip component.
 */
const TrustBar = ({ items, variant = "light" }: TrustBarProps) => {
  const s = variantStyles[variant];

  return (
    <section className={`${s.bg} py-10 md:py-14`}>
      <div className="mx-auto max-w-wide px-5 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {items.map((item, i) => (
            <div key={i}>
              <span className={`block font-headline text-3xl md:text-4xl ${s.value}`}>
                {item.value}
              </span>
              <span className={`block font-body text-xs uppercase tracking-widest mt-2 ${s.label}`}>
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
